import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { validateSession } from 'src/app/shared/constants';
import { environment } from 'src/environment';
import { BaseService } from './base.service';
import { UikitService } from './uikit.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  constructor(private http: HttpClient, private uikitService: UikitService, private baseService: BaseService) { }

  validateSession(sessionId: string): Observable<any> {
    const subscriptionUrl = environment.apiEndpoint + environment.version + validateSession;
    const params = new HttpParams()
      .set('session_id', sessionId)
    return this.http.get(subscriptionUrl, { params })
  }
}
